import { render, staticRenderFns } from "./notification-center-layout.vue?vue&type=template&id=f07ce55e&scoped=true"
import script from "./notification-center-layout.vue?vue&type=script&lang=js"
export * from "./notification-center-layout.vue?vue&type=script&lang=js"
import style0 from "./notification-center-layout.vue?vue&type=style&index=0&id=f07ce55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07ce55e",
  null
  
)

export default component.exports